module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar",
    attrs: {
      "data-color": "green",
      "data-image": "../assets/img/sidebar-5.jpg"
    }
  }, [_c('div', {
    staticClass: "sidebar-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "user border-0"
  }, [_c('div', {
    staticClass: "info ml-4"
  }, [_c('span', {
    attrs: {
      "id": "myname"
    }
  }, [_vm._v(_vm._s(_vm.myself))])])]), _vm._v(" "), _c('ul', {
    staticClass: "nav"
  }, [_vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('li', {
    staticClass: "nav-item",
    attrs: {
      "id": "navLink2"
    }
  }, [_c('a', {
    staticClass: "nav-link",
    on: {
      "click": function($event) {
        return _vm.addRFQ();
      }
    }
  }, [_c('i', {
    staticClass: "nc-icon nc-paper-2"
  }), _vm._v(" "), _c('p', [_vm._v("CREATE RFQ")])])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), (!_vm.isProduction) ? _c('li', {
    staticClass: "nav-item",
    attrs: {
      "id": "rfq-testing"
    }
  }, [_vm._m(9)]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "nav-item "
  }, [_c('a', {
    staticClass: "nav-link",
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "nc-icon nc-button-power"
  }), _vm._v(" "), _c('p', [_vm._v("SIGN OUT")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "sidebar-background",
    staticStyle: {
      "background-image": "url(/static/img/sidebar-5.jpg)"
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "img-fluid p-4",
    attrs: {
      "src": require("../assets/raefton-logo.svg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item",
    attrs: {
      "id": "myprofile"
    }
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#/contact/edit"
    }
  }, [_c('i', {
    staticClass: "nc-icon nc-circle-09"
  }), _vm._v(" "), _c('p', [_vm._v("MY PROFILE")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item",
    attrs: {
      "id": "dashboard"
    }
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#/dashboard/view"
    }
  }, [_c('i', {
    staticClass: "nc-icon nc-chart-bar-32"
  }), _vm._v(" "), _c('p', [_vm._v("Dashboard")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item",
    attrs: {
      "id": "asset"
    }
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#/asset/view"
    }
  }, [_c('i', {
    staticClass: "nc-icon nc-bus-front-12"
  }), _vm._v(" "), _c('p', [_vm._v("Assets")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item",
    attrs: {
      "id": "inventory"
    }
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#/inventory/view"
    }
  }, [_c('i', {
    staticClass: "nc-icon nc-app"
  }), _vm._v(" "), _c('p', [_vm._v("Inventory")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item",
    attrs: {
      "id": "navLink1"
    }
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#/rfq/view"
    }
  }, [_c('i', {
    staticClass: "nc-icon nc-delivery-fast"
  }), _vm._v(" "), _c('p', [_vm._v("RFQs")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item",
    attrs: {
      "id": "shipment"
    }
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#/shipment/view"
    }
  }, [_c('i', {
    staticClass: "nc-icon nc-paper-2"
  }), _vm._v(" "), _c('p', [_vm._v("SHIPMENTS "), _c('span', {
    attrs: {
      "id": "num_shippments"
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item",
    attrs: {
      "id": "contact"
    }
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#/contact/view"
    }
  }, [_c('i', {
    staticClass: "nc-icon nc-circle-09"
  }), _vm._v(" "), _c('p', [_vm._v("CONTACTS")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "nav-item",
    attrs: {
      "id": "map"
    }
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#/map"
    }
  }, [_c('i', {
    staticClass: "nc-icon nc-pin-3"
  }), _vm._v(" "), _c('p', [_vm._v("Map")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "nav-link",
    attrs: {
      "href": "#/testing/rfq"
    }
  }, [_c('i', {
    staticClass: "nc-icon nc-circle-09"
  }), _vm._v(" "), _c('p', [_vm._v("RFQ Testing")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e4dcea7a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = 777
// module chunks = 0